<app-pagetoolbar icon="home" label="Dashboard"> </app-pagetoolbar>
<div class="news">
  <app-newsitem-card *ngFor="let i of newsitems" [item]="i"></app-newsitem-card>
</div>
<div class="cards">
  <ng-container *ngIf="showParticipantCount">
    <a [routerLink]="['/participants']">
      <mat-card>
        <mat-card-header>
          <mat-icon mat-card-avatar>group</mat-icon>
          <mat-card-subtitle>Participants</mat-card-subtitle>
          <mat-card-title>{{ participantCount }}</mat-card-title>
        </mat-card-header>
      </mat-card>
    </a>
  </ng-container>
  <ng-container *ngIf="showCurrentMatchingPeriod">
    <a [routerLink]="['/timeline', currentMatchingPeriod]">
      <mat-card>
        <mat-card-header>
          <mat-icon mat-card-avatar>timeline</mat-icon>
          <mat-card-subtitle style="font-size: 120% !important">Current matching period</mat-card-subtitle>
          <mat-card-title>{{ currentMatchingPeriod }}</mat-card-title>
        </mat-card-header>
      </mat-card>
    </a>
  </ng-container>
  <ng-container *ngIf="showLastMatchRun">
    <ng-container *ngIf="currentMatchRun !== 0; else noLink">
      <a [routerLink]="['/matchrun', currentMatchingPeriod, currentMatchRun]">
        <mat-card>
          <mat-card-header>
            <mat-icon mat-card-avatar>autorenew</mat-icon>
            <mat-card-subtitle>Last match run</mat-card-subtitle>
            <mat-card-title>{{ currentMatchRun }}</mat-card-title>
          </mat-card-header>
        </mat-card>
      </a>
    </ng-container>
    <ng-template #noLink>
      <mat-card>
        <mat-card-header>
          <mat-icon mat-card-avatar>autorenew</mat-icon>
          <mat-card-subtitle>Last match run</mat-card-subtitle>
          <mat-card-title>{{ currentMatchRun }}</mat-card-title>
        </mat-card-header>
      </mat-card>
    </ng-template>
  </ng-container>
</div>
